/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AuthedBoardBoardIdRouteImport } from './routes/_authed/board.$boardId'
import { Route as AuthedProgressBoardIdRouteImport } from './routes/_authed/progress.$boardId'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedBoardBoardIdRoute = AuthedBoardBoardIdRouteImport.update({
  id: '/board/$boardId',
  path: '/board/$boardId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProgressBoardIdRoute = AuthedProgressBoardIdRouteImport.update({
  id: '/progress/$boardId',
  path: '/progress/$boardId',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/settings': typeof AuthedSettingsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/board/$boardId': typeof AuthedBoardBoardIdRoute
  '/progress/$boardId': typeof AuthedProgressBoardIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/settings': typeof AuthedSettingsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/': typeof AuthedIndexRoute
  '/board/$boardId': typeof AuthedBoardBoardIdRoute
  '/progress/$boardId': typeof AuthedProgressBoardIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/board/$boardId': typeof AuthedBoardBoardIdRoute
  '/_authed/progress/$boardId': typeof AuthedProgressBoardIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/settings'
    | '/invite/$token'
    | '/board/$boardId'
    | '/progress/$boardId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/settings'
    | '/invite/$token'
    | '/'
    | '/board/$boardId'
    | '/progress/$boardId'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/settings'
    | '/invite/$token'
    | '/_authed/'
    | '/_authed/board/$boardId'
    | '/_authed/progress/$boardId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/board/$boardId': {
      id: '/_authed/board/$boardId'
      path: '/board/$boardId'
      fullPath: '/board/$boardId'
      preLoaderRoute: typeof AuthedBoardBoardIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/progress/$boardId': {
      id: '/_authed/progress/$boardId'
      path: '/progress/$boardId'
      fullPath: '/progress/$boardId'
      preLoaderRoute: typeof AuthedProgressBoardIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedBoardBoardIdRoute: typeof AuthedBoardBoardIdRoute
  AuthedProgressBoardIdRoute: typeof AuthedProgressBoardIdRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedBoardBoardIdRoute: AuthedBoardBoardIdRoute,
  AuthedProgressBoardIdRoute: AuthedProgressBoardIdRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
